var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._v(" "),_c('profile-archive',{attrs:{"loading":_vm.loading,"profiles":_vm.profiles,"page-data":_vm.pageData},on:{"get-page":_vm.getPage}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-10 md:px-16"},[_c('h3',{staticClass:"py-4 font-black uppercase text-neutral-900"},[_vm._v("Artist")])])
}]

export { render, staticRenderFns }